import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import { appContext } from '../../util/decorators';
import Picture from '../Picture.jsx';
import blogConfig from '../../config/blogConfig.json';
import podcastConfig from '../../config/podcastConfig.json';

const mapStateToProps = state => ({
  routeParams: state.routeParams,
  siteBlogs: blogConfig[state.country],
  sitePodcasts: podcastConfig[state.country],
});

@connect(mapStateToProps)
@appContext
export default class AuthorInfoSmall extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /* eslint react/no-did-mount-set-state: 0 */
    if (!this.refs.description) return;
    this.setState({
      showEverything: this.refs.description.offsetHeight < 125,
      loaded: true,
    });
  }

  showEverything(event) {
    event.preventDefault();
    this.setState({ showEverything: true });
  }

  render() {
    const t = this.context.app.t;
    const { sitePodcasts, siteBlogs, routeParams: { blogs, podcasts } } = this.props;
    const { loaded, showEverything } = this.state;

    let info;
    if (blogs) {
      info = _.find(siteBlogs, { id: blogs });
    } else if (podcasts) {
      info = _.find(sitePodcasts, { id: podcasts });
    }
    if (!info) return null;

    const round = require(`../../../assets/media-images/${info.images.round}`);

    return (
      <div className="author-info author-info-small">
        <div className="row">
          <Picture className="col-xs-4" src={round} alt={info.author} />
          <div className="col-xs-8" onClick={this.showEverything.bind(this)}>
            <h4>{info.name}</h4>
            <div className={cx('description', { 'hide-partially': loaded && !showEverything, 'not-loaded': !loaded })} ref="description">
              {info.description}
            </div>
            <a className="text-colored-link more-link" href="#">+ {t('AuthorInfo.show_all')}</a>
          </div>
        </div>
      </div>
    );
  }
}

AuthorInfoSmall.propTypes = {
  sitePodcasts: React.PropTypes.array,
  siteBlogs: React.PropTypes.array,
  routeParams: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/AuthorInfoSmall.jsx